const getErrorString = (error: any): string => {
  try {
    return (error as Error).message;
  }
  catch (ex) {
    //
  }
  try {
    return (error as Error).toString();
  }
  catch (ex) {
    //
  }
  return 'error';
};

const info = (message: string, data: any) => {
  console.log(message, _getJsonStr(data));
};

const warn = (message: string, data: any) => {
  console.warn(message, _getJsonStr(data));
};

const error = (message: string, data: any) => {
  console.error(message, _getJsonStr(data));
};

const _getJsonStr = (data: any) => {
  if (data === null || data === undefined) {
    return data;
  }
  try {
    return JSON.stringify(data);
  }
  catch (ex) {
    //
  }
  return 'json_stringify_error';
};

export const Logger = {
  info,
  warn,
  error,
  getErrorString
};
